import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { WalletCard } from './WalletCard';

export const Loading = memo(() => {
    return (
        <WalletCard
            disabled
            balance={<Skeleton />}
            canConvert={false}
            currencyCode={<Skeleton width={36} />}
            currencyName={<Skeleton width={100} />}
            IconFlag={<Skeleton height={28} />}
        />
    );
});

Loading.displayName = 'Loading';
